import React, { createContext, useContext } from "react";

interface IRoundMapContext {
    isEdit?: boolean
    format?: string
}

const RoundMapContext = createContext<IRoundMapContext>({

})

const RoundMapProvider = ({ children, isEdit }: { children: React.ReactNode } & IRoundMapContext) => {

    return <RoundMapContext.Provider value={{ isEdit }}>
        {children}
    </RoundMapContext.Provider>
}

const useRoundMap = () => useContext(RoundMapContext)

export { RoundMapProvider, useRoundMap };
